













import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-blog',
  components: ServiceContainer().getComponents()
})



export default class extends Vue {
  @Prop({default: () => ('')}) private blogpages!: string;
  private blogs: object = {};

  async created() {
    this.productBlog();
  }

  private productBlog() {
    if (this.blogpages) {
      this.$solarClient.post(`/api/catalog/blog`, {blogs: this.blogpages}).then(res => {
        this.blogs = res.data;
      })
    }
  }
}
